export interface UpdateUserBody {
    id: number;

    userName: string;

    password: string;
}
